
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import DocumentType from '@/extend/classes/DocumentType';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeDocumentType' })

export default class storeDocumentType extends VuexModule {
  // States
  private reccords: DocumentType[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get documentTypeLoading (): boolean {
    return this.dataLoading;
  }
  private get documentTypeRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get documentTypeLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewDocumentType() {
    return (): DocumentType => { 
      return this.getDocumentType(0, true);
    }
  }

  
  public get getDocumentType () {
    return (id: number, canCreate = false): DocumentType => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id DocumentType can't be 0")
        return new DocumentType();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new DocumentType();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            DocumentType.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromDocumentType(data.reccords[0] as DocumentType);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listDocumentType (): DocumentType[] {
    return this.reccords;
  }

  public get listConfigDocumentType (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mDocumentTypeRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mDocumentTypeClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mDocumentTypeLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mDocumentTypeLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(DocumentType.fromJson(reccord as DocumentType));
    })
    DocumentType.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mDocumentTypeConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mDocumentTypeCreated (obj: DocumentType): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareDocumentType(obj)) {
          api.fromDocumentType(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareDocumentType(obj)) {
            api.fromDocumentType(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mDocumentTypeUpdated (obj: DocumentType): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareDocumentType(obj)) {
          api.fromDocumentType(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mDocumentTypeDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerDocumentType (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.documentTypeRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerDocumentType(this.documentTypeCreated, this.documentTypeUpdated, this.documentTypeDeleted);
          this.mDocumentTypeRegistered();
        } else {
          setTimeout(() => resolve(this.registerDocumentType(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.documentTypeLoading && !this.documentTypeLoaded) {
          this.mDocumentTypeLoading(true);
          return DocumentType.list(filter)
            .then((data: ListData) => {
              this.mDocumentTypeLoaded(data);
              this.mDocumentTypeLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredDocumentType (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.documentTypeLoading) {
        this.mDocumentTypeLoading(true);
        return DocumentType.list(filter)
          .then((data: ListData) => {
            this.mDocumentTypeLoaded(data);
            this.mDocumentTypeLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  private documentTypeCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mDocumentTypeConfigUpdated(config)
    const obj = objConfig.obj as DocumentType;
    this.mDocumentTypeCreated(DocumentType.fromJson(obj));
  }

  @Action
  private documentTypeUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mDocumentTypeConfigUpdated(config)
    const obj = objConfig.obj as DocumentType;
    this.mDocumentTypeUpdated(DocumentType.fromJson(obj));
  }

  @Action
  private documentTypeDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as DocumentType;
    this.mDocumentTypeDeleted(obj.id);
  }
}
